'use client';

import React, { PropsWithChildren } from "react";
import { Navbar } from "../organisms/layout/navbar";
import Footer from "../organisms/layout/footer";
import AuthProvider from "@/services/providers/AuthProvider";


const MainLayout = ({ children }: PropsWithChildren) => {
	return (
		<AuthProvider>
			<div className="w-full !overflow-x-hidden !bg-[var(--gradient-olive-gold-beige)]">
				<Navbar />
				{children}
				<Footer />
			</div>
		</AuthProvider>
	);
};

export default MainLayout;